import {cache0} from "../../utils/cache0";

export const isEdge = cache0(() => /Edge\/./i.test(navigator.userAgent));

export const isIe = cache0(() => /MSIE 9|MSIE 10|rv:11.0/i.test(navigator.userAgent));

export const isFirefox = cache0(()=>/Firefox/i.test(navigator.userAgent));
